import Storage from '@/utils/storage';
import router from '@/router';
import {
  RESET_AUTH, PURGE_AUTH, ERROR_AUTH, SET_TOKEN, SET_BEARER, SET_TOKEN_DATA, SET_USER_DATA,
} from '../mutation-types';
import AuthService from '@/services/AuthService';
import Http from "@/plugins/http";

// state
const localState = () => ({
  userId: Storage.get('userId'),
  bearer: Storage.get('bearer') || 'Bearer ',
  token: Storage.get('token'),
  user: {},
  errorAuthen: ''
});

// mutations
const mutations = {
  [RESET_AUTH](state) {
    Object.assign(state, localState());
  },

  [PURGE_AUTH](state) {
    state.userId = '';
    state.token = '';
    state.user = {};
    Storage.clear();
  },

  [SET_TOKEN](state, {
    user, token
  }) {
    console.log(user)
    state.user = {...user};
    state.userId = user.id;
    state.token = token;
    Storage.set('user', JSON.stringify(state.user));
    Storage.set('userId', state.userId);
    Storage.set('token', state.token);
  },

  // set only token
  [SET_TOKEN_DATA](state, token) {
    if(token){
      state.token = token;
      Storage.set('token', state.token);
    }
  },

  // set only user
  [SET_USER_DATA](state, user) {
    state.user = {...state.user, ...user};
    // Storage.set('user', JSON.stringify(state.user));
  },

  [SET_BEARER](state, data) {
    state.bearer = data;
    Storage.set('bearer', data);
  },

  [ERROR_AUTH](state, errorAuthen) {
    state.errorAuthen = errorAuthen;
  },

};

// actions
const actions = {
  async forgot({ }, email) {
    const feUrl = process.env.VUE_APP_FE_URL ||
                  ('https://' + location.host)
    const returnUrl = `${feUrl}/reset-password?token=:token`
    let user = await AuthService.forgot({email, returnUrl});

    return user; // return result for toast
  },
  async resetPassword({ }, {password, token}) {
    let user = await AuthService.resetPassword({
      password: password,
      token: token
    });

    return user; // return result for toast
  },
  async login({ commit }, infomation) {
    let user = await AuthService.login(infomation);
    
    if(user.error) {
      commit(ERROR_AUTH, user.error);
      return user.error.message;
    } else {
      const token = user.password;
      delete user.password;
      commit(SET_BEARER, user.email);
      commit(SET_TOKEN, {user, token});

      commit("location/SET_CURRENT_LOCATION", {
        languages: user.languages,
        country: user.country,
        region: user.state,
        city: user.city,
      }, { root: true });

      // reset header
      Http.resetHeader();

      return;
    }
  },
  async logout({ commit, rootState }) {
    commit(PURGE_AUTH);
    rootState.chat.friends = [];
    rootState.chat.conversationMap = {};
    rootState.chat.friendsDate = null;
    rootState.chat.openedChatBoxes = [];
    rootState.chat.activeChats = [];
    rootState.chat.showListFriend = 'false';
    router.push({name: 'login'})
  },
  async registerMember({ commit }, infomation) {
    let user = await AuthService.register(infomation);
    if(user.error) {
      commit(ERROR_AUTH, user.error);
      return user.error.message;
    } else {
      const token = user.password;
      delete user.password;
      commit(SET_BEARER, user.email);
      commit(SET_TOKEN, {user, token});
      return;
    }
  },
  async accountUpdate({}, data){
    let profile = await AuthService.changePassword(data);
    return profile; // return result for toast
  },
  async profileUpdate({state}, data){
    let output = {
      "firstName": state.user.firstName,
      "lastName": state.user.lastName,
      "subRoles": state.user.subRoles,
      ...data
    }
    let profile = await AuthService.profileUpdate(output);
    return profile; // return result for toast
  },
  async descriptionUpdate({}, data){
    let profile = await AuthService.descriptionUpdate(data);
    return profile; // return result for toast
  },
  async avatarUpdate({commit}, data) {
    let avatar = await AuthService.avatarUpdate({photoContent: data});
    if(avatar && !avatar.error) commit("setUserData", { picture: avatar.picture });
    return avatar;
  },
  async coverUpdate({commit}, data) {
    let cover = await AuthService.coverUpdate({coverContent: data});
    if(cover && !cover.error) commit("setUserData", { cover: cover.cover });
    return cover; // return result for toast
  },
  async getMe({state, commit}){
    if(!state.user.id){
      const data = await AuthService.getMe();
      if(data && !data.error) commit(SET_USER_DATA, data)
    }
    return true; // return result for toast
  },
  setTotalPost({state, commit}, data){
    let totalPost = (state.user.totalPost || 0) + data;
    commit(SET_USER_DATA, {totalPost})
  },
  setTotalFollowing({state, commit}, data){
    let totalFollowing = (state.user.totalFollowing || 0) + data;
    commit(SET_USER_DATA, {totalFollowing})
  },
  setTotalCoursePlayed({state, commit}, data){
    let totalCoursePlayed = (state.user.totalCoursePlayed || 0) + data;
    commit(SET_USER_DATA, {totalCoursePlayed})
  },
};

export default {
  state: localState(),
  mutations,
  actions,
};
